//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { Toast } from 'mint-ui'
import { mapState } from 'vuex'
import qr from 'qr-image'

export default {
  name: 'home-page',
  data() {
    return {
      mobile: '',
      smsCode: '',
      qrCode: ''
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
    console.log(this.$route)
    this.getQrCode(this.user.qrCodeUrl)
  },
  updated: function () {
    if (!this.qrCode) {
      this.getQrCode(this.user.qrCodeUrl)
    }
  },
  methods: {
    getQrCode (url) {
      if (!url) return ''
      let qrCode = qr.imageSync(url, 'L')
      qrCode = qrCode.toString('base64')
      this.qrCode = qrCode
      return qrCode
    }
  }
}
